const COMPILED_CONSTANTS = {
    "evolveNexusPublicApiGatewayId": "ob8vknxw9k",
    "AppConfigConfigurationProfileFeatureFlagsId": "u9dxiwi",
    "AppConfigEnvironmentId": "5vfuzfm",
    "AppConfigApplicationId": "to7nk1g",
    "nexusApiGatewayId": "pqnsfqycde",
    "nexusPublicApiGatewayId": "siq2pgt3di",
    "nexusUserPoolId": "us-east-1_0BUvKVzJa",
    "nexusSecurityGroupId": "sg-007375105849f4d86",
    "nexusCognitoDomain": "nexus-vbc-667037895408-us-east-1",
    "nexusUserPoolClientId": "456qrh7o5m1lhlh1rt8snt9n0f",
    "nexusNascoNexusRedshiftRole": "arn:aws:iam::667037895408:role/nasco-nexus-redshift-role-nexus",
    "nexusRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:667037895408:workgroup/0f36eb77-1c9b-4877-976c-3462e883b6c6",
    "nexusCognitoSecurityGroupArn": "sg-08839b2533c573784",
    "nexusLambdaSecurityGroupArn": "sg-053236aee480a9141",
    "nexusWardenSecurityGroupArn": "sg-0c1f62ba159921657",
    "auroraPostgresSecurityGroupArn": "sg-0c41352bc553d5847",
    "nexustoprocessBucketName": "nexus-to-process-667037895408-us-east-1",
    "nexusfailedprocessingBucketName": "nexus-failed-processing-667037895408-us-east-1",
    "nexusprocessedBucketName": "nexus-processed-667037895408-us-east-1",
    "nexusdynamoBucketName": "nexus-dynamo-667037895408-us-east-1",
    "nexusquarantineBucketName": "nexus-quarantine-667037895408-us-east-1",
    "nascoNexusLambdaExecutionRoleArn": "arn:aws:iam::667037895408:role/nasco-nexus-lambda-execution-role",
    "nexusEvolveHomeCloudFrontDistributionId": "E2LUW052P1UE4F",
    "nexusEvolveHomeCloudFrontDistributionArn": "arn:aws:cloudfront::667037895408:distribution/E2LUW052P1UE4F",
    "nexusEvolveHomeFrontendBucket": "nexus-evolve-home-frontend-667037895408-us-east-1",
    "nexusNewSubDomain": "vbc.nexus.fe",
    "nexusFrontendBucket": "nexus-frontend-667037895408-us-east-1",
    "nexusCloudFrontDistributionId": "E35XJB8UGRU7R8",
    "nexusCloudFrontDistributionArn": "arn:aws:cloudfront::667037895408:distribution/E35XJB8UGRU7R8",
    "nexusProjectPrefix": "nexus",
    "nexusNascoDomain": "vbps.bcbsm-uat.nasco.com",
    "nexusApiProxyUrl": "https://nexus-proxy.vbps.bcbsm-uat.nasco.com",
    "nexusAwsAccId": "667037895408",
    "nexusnexusApiDomainNameDomainNameArn": "arn:aws:apigateway:us-east-1:667037895408:/domainnames/nexus.vbps.bcbsm-uat.nasco.com+dz8v38nik5",
    "nexusApiCloudFrontDistributionArn": "arn:aws:cloudfront::667037895408:distribution/E1OFBOLKYGQ91T",
    "evolveAppInferenceProfileArn": "arn:aws:bedrock:us-east-1:667037895408:application-inference-profile/uks4g0pckwya",
    "evolveAppInferenceProfile46Arn": "arn:aws:bedrock:us-east-1:667037895408:application-inference-profile/cn2avroczmy4",
    "evolveContractIngestionApiGatewayId": "h5mw4uua6l",
    "evolveSettlementApiGatewayId": "11xfu1r20b",
    "evolveNexusApiGatewayId": "9gctgv1tl9",
    "evolveOSApiGatewayId": "88yag8kn33",
    "evolveNascoNexusRedshiftRole": "arn:aws:iam::667037895408:role/nasco-evolve-redshift-role-nexus",
    "evolveRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:667037895408:workgroup/89cd5282-b8f6-4c86-924e-82097f38745d",
    "RedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:667037895408:workgroup/89cd5282-b8f6-4c86-924e-82097f38745d",
    "evolveRedshiftSnapshotLambdaRoleArn": "arn:aws:iam::667037895408:role/nasco-evolve-redshift-snapshot-lambda-role",
    "evolvenexusToProcessBucketName": "evolve-nexus-to-process-667037895408-us-east-1",
    "evolvemediaBucketName": "evolve-media-667037895408-us-east-1",
    "evolvesynthDataBucketName": "evolve-synth-data-667037895408-us-east-1",
    "evolveAwsAccountId": "667037895408",
    "evolvenexusFailedProcessingBucketName": "evolve-nexus-failed-processing-667037895408-us-east-1",
    "evolvemigrationBucketName": "evolve-migration-667037895408-us-east-1",
    "evolvereportsBucketName": "evolve-reports-667037895408-us-east-1",
    "evolvedevBucketName": "evolve-dev-667037895408-us-east-1",
    "evolvesettlementArtifactsBucketName": "evolve-settlement-artifacts-667037895408-us-east-1",
    "evolvenexusProcessedBucketName": "evolve-nexus-processed-667037895408-us-east-1",
    "evolvequarantineBucketName": "evolve-quarantine-667037895408-us-east-1",
    "evolvetemporaryBucketName": "evolve-temporary-667037895408-us-east-1",
    "evolveflowArtifactsBucketName": "evolve-flow-artifacts-667037895408-us-east-1",
    "evolvedynamoBucketName": "evolve-dynamo-667037895408-us-east-1",
    "evolvecontractUploadsBucketName": "evolve-contract-uploads-667037895408-us-east-1",
    "evolveexportDynamoBucketName": "evolve-export-dynamo-667037895408-us-east-1",
    "evolvememoriesBucketName": "evolve-memories-667037895408-us-east-1",
    "securityGroupId": "sg-03be08567ec66c1a7",
    "evolveUserPoolId": "us-east-1_JBq9VKdwl",
    "evolveGuardDutyMalwareAlertTopicArn": "arn:aws:sns:us-east-1:667037895408:guardduty-malware-alerts",
    "evolveUserPoolClientId": "4h1jo294s138devljgr0ovmmia",
    "evolveCognitoDomain": "vbc-667037895408-us-east-1",
    "evolveSecurityGroupId": "sg-03be08567ec66c1a7",
    "evolveNexusCloudFrontDistributionArn": "arn:aws:cloudfront::667037895408:distribution/E2H1OPKEUVWRFI",
    "evolveNexusCloudFrontDistributionId": "E2H1OPKEUVWRFI",
    "evolveNexusFrontendBucket": "evolve-nexus-frontend-667037895408-us-east-1",
    "evolveNexusSubDomain": "vbc.nexus",
    "evolveOSFrontendBucketName": "evolve-os-frontend-667037895408-us-east-1",
    "evolveOSCloudFrontDistributionArn": "arn:aws:cloudfront::667037895408:distribution/E3BSGNQD0C3Y2A",
    "evolveOSSubDomain": "vbc.os",
    "evolveOSCloudFrontDistributionId": "E3BSGNQD0C3Y2A",
    "evolveNascoDomain": "vbps.bcbsm-uat.nasco.com",
    "evolveApiProxyUrl": "https://vbc-proxy.vbps.bcbsm-uat.nasco.com",
    "evolveApiCloudFrontDistributionArn": "arn:aws:cloudfront::667037895408:distribution/ETYEZUDEEUH0A",
    "signingProfileVersionArn": "arn:aws:signer:us-east-1:667037895408:/signing-profiles/signingProfile_iGLsn6toeno2/8oKkW1wRr4",
    "custodianRoleName": "nasco-c7n",
    "errorTopicArn": "arn:aws:sns:us-east-1:667037895408:c7n-errors",
    "signingProfileName": "signingProfile_iGLsn6toeno2",
    "scheduleGroupName": "CloudCustodian",
    "policySGId": "sg-0b9d3ee921e03339e",
    "custodianRoleArn": "arn:aws:iam::667037895408:role/nasco-admin/nasco-c7n",
    "scheduleRoleArn": "arn:aws:iam::667037895408:role/nasco-admin/nasco-c7n-schedule",
    "custodianAdminRoleArn": "arn:aws:iam::667037895408:role/nasco-admin/nasco-c7n-admin",
    "tenableOneRoleArn": "arn:aws:iam::667037895408:role/nasco-admin/nasco-tenable-one",
    "bedrockLogging": "Yes",
    "logicMonitorRoleArn": "arn:aws:iam::667037895408:role/nasco-admin/nasco-logicmonitor",
    "snsKMSKeyAliasName": "alias/nasco/sns",
    "cfLoggingBucketName": "cloudfront-logs-667037895408-us-east-1",
    "s3LoggingBucketName": "s3-access-logs-667037895408-us-east-1",
    "breakGlassRoleArn": "arn:aws:iam::667037895408:role/nasco-admin/nasco-break-glass",
    "permsBoundaryPolicyARN": "arn:aws:iam::667037895408:policy/nasco/builder-permissions-boundary",
    "deploymentBucketName": "deployment-667037895408-us-east-1",
    "opsPermsBoundaryPolicyARN": "arn:aws:iam::667037895408:policy/nasco/ops",
    "BaselineCloudFrontACLARN": "arn:aws:wafv2:us-east-1:667037895408:global/webacl/NASCO-CloudFront-Baseline/2c0ac6ab-f09f-4d5c-aef7-6d26acfeca66",
    "TerraformStateBucketName": "tfstate-667037895408-us-east-1",
    "oidcProviderArn": "arn:aws:iam::667037895408:oidc-provider/api.bitbucket.org/2.0/workspaces/nascodevelopment/pipelines-config/identity/oidc",
    "LocalSecurityTopicName": "aws-controltower-SecurityNotifications",
    "LocalSecurityTopic": "arn:aws:sns:us-east-1:667037895408:aws-controltower-SecurityNotifications",
    "BaselineConfigDeliveryChannel": "aws-controltower-BaselineConfigDeliveryChannel",
    "BaselineConfigRecorder": "aws-controltower-BaselineConfigRecorder",
    "BaselineConfigRole": "arn:aws:iam::667037895408:role/aws-controltower-ConfigRecorderRole",
    "env": "dev"
}
export { COMPILED_CONSTANTS }